import React, { useContext, useEffect, useState } from "react";
import Wrapper from "../components/wrapper/Wrapper";
import itinerary_details_banner from "../images/ladakh_landing_banner.jpg";
import itinerarydetailsMob from "../images/itinerary_details_banner_mobile.jpg";
import bottomarrow from "../images/down_arrow.png";
import getintouch from "../images/get_in_touch.png";
import ItineryContent from "../components/ItinerayContent";
import { useParams } from "react-router-dom";
import { ThemeContext } from "../Context/Theme/Context";
import ItineryList from "../components/ItineryList";

const ItineryDetails = () => {
  const { title, category } = useParams();
  console.log("title, category", title, category);
  const { mainCategory } = useContext(ThemeContext);
  const [mainData, setMainData] = useState();


  useEffect(() => {
    const data1 = mainCategory?.find((item) => {
      return item.slug === title;
    });
    setMainData(data1);
  }, [mainCategory, title]);

  return (
    <Wrapper
      desktopImage={mainData?.image ? process.env.react_app_base_url + "/" + mainData?.image : itinerary_details_banner}
      mobileImage={mainData?.meta_tag ? process.env.react_app_base_url + "/" + mainData?.meta_tag : itinerarydetailsMob}
      firstTitle={mainData?.sub_heading ?? 'a deep dive'}
      bannerHeading={mainData?.title}
      scrolldown="scroll down"
      bottomarrow={bottomarrow}
      topfootHead={mainData?.get_in_touch ?? 'Get in Touch!'}
      topfootPara={mainData?.get_in_touch_details ?? "Get in touch for any Himalayan travel insights—we're here to help. Enjoy a free consultation call, whether you’re planning a trip or need advice on an itinerary. "}
      bookCall="Book a Discovery Call"
    >
      <div className="container inner-container">
        <div className="itinerylist">
          <ul>
            {mainData?.feature?.map((itiListItem, i) => (
                <ItineryList
                  itiListIcon={process.env.react_app_base_url + "/" + itiListItem.icon}
                  title={itiListItem.title}
                  countValue={itiListItem.desc}
                />
              ))
            }
          </ul>

        </div>


        <div className="itiner_cont_wrapper">
          {mainData?.itinerary_desc?.map((itineraryitem, i) => (
            <ItineryContent
              smallTitle={mainData?.title}
              heading={itineraryitem.title}
              description={itineraryitem.desc}
              getintouch={getintouch}
              btnText={mainData?.get_in_touch ?? 'Get in Touch!'}
              getAlt="get_in_touch"
              itiContentImg={process.env.react_app_base_url + "/" + itineraryitem.icon}
              itiImgAlt="why_trip_1"
              align={i % 2 === 0 ? "left" : "right"}
              query={mainData?.slug}
            />
          ))}
        </div>
      </div>
    </Wrapper>
  );
};

export default ItineryDetails;
